import { render, staticRenderFns } from "./RejectReasonView.vue?vue&type=template&id=b4294492"
import script from "./RejectReasonView.vue?vue&type=script&lang=js"
export * from "./RejectReasonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports